/* =====================================================================
   ExtraCM · tema de Shopify · página de producto (configurador de /buy)
   Mismo comportamiento que buy/index.html, con los precios de Shopify
   (window.ECM.products) y el carrito de theme.js.
   ===================================================================== */
(function () {
  'use strict';
  var ECM = window.ECM || {}, TH = window.ECMTheme;
  if (!TH || !ECM.products) return;
  var t = TH.t, tt = TH.tt, money = TH.money, CUR = TH.CUR;
  var $ = function (id) { return document.getElementById(id); };

  var galMain = $('galleryMain'), galThumbs = $('galleryThumbs'), heightsEl = $('heights'), packsEl = $('packs');
  var sizesEl = $('sizes'), unitTog = $('unitToggle'), addBtn = $('addBtn'), bundleCardEl = $('bundleCard');
  if (!heightsEl || !addBtn) return;

  /* ---- precios por altura y pack (mismos multiplicadores que la web) ----
     Shopify TRUNCA el descuento por unidad a 2 decimales: 35,99 × 15 % =
     5,3985 → descuenta 5,39. qp() lo replica para que la web y el checkout
     digan lo mismo. */
  /* Packs del mentor, propuesta 1 con el par a 40,99 € (24-oct-2026): 35,99 / 32,99 / 29,99 € por par en la
     de 5 cm en euros → 12,20 % / 19,52 % / 26,84 %, igual que los descuentos automáticos de Shopify (en las
     demás monedas y alturas el mismo % deja céntimos sueltos). 4 pares tiene el de 3. Tachado: 49,99 €. */
  var OFF = { 1: 0, 2: 0.1220, 3: 0.1952, 4: 0.1952, 5: 0.2684 };
  var QDEC = (TH.FMT && TH.FMT.decimals === 0) ? 1 : 100;   // Shopify trunca el descuento a la precisión de la moneda (CLP/COP/JPY: unidades)
  function qp(b, o) { return b - Math.floor(b * o * QDEC + 1e-9) / QDEC; }
  function base(h) { var p = ECM.products[h]; return p ? p.price / 100 : 0; }
  function perPairFor(h, qty) { var q = Math.min(Math.max(qty, 1), 5); return qp(base(h), OFF[q]); }
  function saveLabel(h, q) {
    if (q === 1) return t('You save ') + TH.moneyMajor(h === 'bundle' ? CUR.bundleSurplus : CUR.surplus, true);
    // sobre el precio tachado (par + recargo del mercado), como el recuadro de abajo (decisión del usuario, 23-oct)
    var was = perPairFor(h, 1) + (h === 'bundle' ? CUR.bundleSurplus : CUR.surplus);
    return t('{pct}% off', { pct: Math.round((was - perPairFor(h, q)) / was * 100) });
  }

  var HANDLE_TO_HEIGHT = {};
  Object.keys(ECM.products).forEach(function (h) { if (ECM.products[h]) HANDLE_TO_HEIGHT[ECM.products[h].handle] = h; });
  var selHeight = HANDLE_TO_HEIGHT[ECM.currentHandle] || '5', selPack = 2, selSize = 'L', sizeSyncing = false;   // 2 pares y talla L marcados (23-oct)

  /* ---- galería ---- */
  if (galThumbs && galMain) {
    galThumbs.querySelectorAll('.thumb').forEach(function (th) {
      th.addEventListener('click', function () {
        galThumbs.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('active'); });
        th.classList.add('active');
        var big = th.dataset.img;
        galMain.srcset = galSrcset(big); galMain.src = big;
      });
    });
  }
  function galSrcset(big) {
    // En Shopify las variantes de tamaño comparten nombre: pack.webp → pack-800.webp
    return big.replace(/\.webp(\?|$)/, '-800.webp$1') + ' 800w, ' + big.replace(/\.webp(\?|$)/, '-1100.webp$1') + ' 1100w, ' + big + ' 1400w';
  }

  /* ---- unidad cm / in ---- */
  function setUnit(unit) {
    if (unitTog) unitTog.querySelectorAll('button').forEach(function (b) { b.classList.toggle('active', b.dataset.unit === unit); });
    document.querySelectorAll('.height-cm').forEach(function (el) { el.hidden = unit !== 'cm'; });
    document.querySelectorAll('.height-in').forEach(function (el) { el.hidden = unit !== 'in'; });
  }
  if (unitTog) unitTog.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { setUnit(b.dataset.unit); }); });
  setUnit(CUR.unit);

  /* ---- selección de altura, pack y talla ---- */
  function clearHeights() {
    heightsEl.querySelectorAll('.height-pill').forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-checked', 'false'); });
    if (bundleCardEl) bundleCardEl.classList.remove('active');
  }
  function selectHeight(h) {
    clearHeights();
    if (h === 'bundle') { if (bundleCardEl) bundleCardEl.classList.add('active'); }
    else { var b = heightsEl.querySelector('.height-pill[data-height="' + h + '"]'); if (b) { b.classList.add('active'); b.setAttribute('aria-checked', 'true'); } }
    selHeight = h;
    updatePackPrices(); updateAddBtn();
    // la URL refleja el producto elegido (cada altura es un producto en Shopify)
    try { var p = ECM.products[h]; if (p && p.url && location.pathname !== p.url) history.replaceState(null, '', p.url + location.search); } catch (e) {}
  }
  // eventos del panel /stats (mismos nombres y datos que la web)
  function stat(n, props) { try { (window.ecmq = window.ecmq || []).push([n, props]); } catch (e) {} }
  heightsEl.querySelectorAll('.height-pill').forEach(function (b) { b.addEventListener('click', function () { selectHeight(b.dataset.height); stat('select_pack', { pack: String(selPack), height: selHeight }); }); });
  if (bundleCardEl) bundleCardEl.querySelector('.bundle-card__btn').addEventListener('click', function () { selectHeight('bundle'); stat('select_pack', { pack: 'bundle', height: 'bundle' }); });
  if (packsEl) packsEl.querySelectorAll('.pack').forEach(function (b) {
    b.addEventListener('click', function () {
      packsEl.querySelectorAll('.pack').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active'); selPack = parseInt(b.dataset.pack, 10); updateAddBtn();
      stat('select_pack', { pack: selHeight === 'bundle' ? 'bundle' : String(selPack), height: selHeight });
    });
  });
  if (sizesEl) sizesEl.querySelectorAll('.size').forEach(function (b) {
    b.addEventListener('click', function () {
      sizesEl.querySelectorAll('.size').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active'); selSize = b.dataset.size; updateAddBtn();
      // la sincronización inicial con el desplegable no es una elección del cliente
      if (!sizeSyncing) stat('select_size', { size: String(selSize), system: /^[SMLX]+$/.test(String(selSize)) ? 'letter' : 'number' });
    });
  });

  function updatePackPrices() {
    if (!packsEl) return;
    packsEl.querySelectorAll('.pack').forEach(function (b) {
      var n = parseInt(b.dataset.pack, 10), priceEl = b.querySelector('.pack__price'), saveEl = b.querySelector('.pack__save');
      if (priceEl) priceEl.textContent = TH.moneyMajor(perPairFor(selHeight, n));
      if (saveEl) saveEl.textContent = saveLabel(selHeight, n);
    });
  }
  function updateAddBtn() {
    updateGifts();
    var p = ECM.products[selHeight], v = p && p.variants[selSize];
    if (p && selSize && v && v.available) {
      addBtn.disabled = false;
      // sin precio en el botón: ya sale justo encima, en el recuadro (usuario, 23-oct)
      addBtn.innerHTML = t('<span>Add to cart<span class="btn__sub">90-DAY RISK-FREE · DISCREET SHIPPING</span></span>');
    } else if (!p) {
      addBtn.disabled = true; addBtn.innerHTML = t('<span>Pick a height first<span class="btn__sub">Step 01</span></span>');
    } else {
      addBtn.disabled = true; addBtn.innerHTML = t('<span>Pick a size<span class="btn__sub">Step 03</span></span>');
    }
    updateLivePrice();
  }

  /* ---- precio en vivo + precio del hero (tachado = base + recargo del mercado) ---- */
  var lpCurrent = $('lpCurrent'), lpOriginal = $('lpOriginal'), lpBadge = $('lpBadge');
  var heroWas = $('heroPriceWas'), heroNow = $('heroPriceNow'), heroSave = $('heroPriceSave');
  function updateLivePrice() {
    if (!lpCurrent) return;
    var qty = selPack || 1, current = perPairFor(selHeight, qty) * qty;
    var surplus = selHeight === 'bundle' ? CUR.bundleSurplus : CUR.surplus;
    var original = (perPairFor(selHeight, 1) + surplus) * qty;
    // 1 par: sin tachado ni "ahorra" (el par suelto no debe parecer rebajado; 23-oct)
    var pct = qty === 1 ? 0 : Math.round(((original - current) / original) * 100);
    // barra de cuenta atrás de la cabecera: el descuento de 1 par con la misma regla (recargo del mercado)
    var offerPct = document.querySelector('.offer-bar__pct');
    if (offerPct) { var one = perPairFor(selHeight, 1); offerPct.textContent = offerPct.textContent.replace(/\d+/, String(Math.round(surplus / (one + surplus) * 100))); }
    lpCurrent.textContent = TH.moneyMajor(current); lpOriginal.textContent = TH.moneyMajor(original);
    if (pct > 0) { lpBadge.textContent = tt('Save {pct}%', { pct: pct }); lpBadge.classList.remove('hide'); lpOriginal.style.display = ''; }
    else { lpBadge.classList.add('hide'); lpOriginal.style.display = 'none'; }
    // precio de arriba (junto al título): SIEMPRE el de 1 par, tachado y ahora; con el pack de 2 marcado
    // salía el total de 2 pares y parecía caro sin decir que eran dos (usuario, 23-oct)
    var oneNow = perPairFor(selHeight, 1), oneWas = oneNow + surplus;
    if (heroWas) heroWas.textContent = TH.moneyMajor(oneWas);
    if (heroNow) heroNow.textContent = TH.moneyMajor(oneNow);
    if (heroSave) {
      if (!heroSave.classList.contains('hero__price-save--flash')) heroSave.textContent = tt('SAVE {pct}%', { pct: Math.round(surplus / oneWas * 100) });
      heroSave.style.display = surplus > 0 ? '' : 'none';
      if (heroWas) heroWas.style.display = surplus > 0 ? '' : 'none';
    }
  }

  /* ---- tarjeta del pack de 3 alturas: ahora / tachado (3 × el tachado del par de 5 cm, ver CUR.bundleSurplus en theme.js) ---- */
  (function () {
    var bN = document.querySelector('.bundle-card__now'), bW = document.querySelector('.bundle-card__was');
    if (bN) bN.textContent = TH.moneyMajor(base('bundle'));
    var bWas = base('bundle') + (CUR.bundleSurplus || 0);
    if (bW) bW.textContent = TH.moneyMajor(bWas);
    // 24-oct-2026: el "ahorra 22 %" era fijo; ahora sale del tachado (94,99 frente a 149,97 € → 37 %), como en los packs.
    // Se calcula en cada mercado y se cambia solo el número del texto traducido ("22%", "22 %", "22%OFF").
    var bOff = document.querySelector('.bundle-card__off'), pct = Math.round((1 - base('bundle') / bWas) * 100);
    if (bOff && pct > 0 && pct < 90) bOff.textContent = bOff.textContent.replace(/\d+(?=\s?%)/, pct);
  })();

  /* ---- talla: el desplegable manda sobre los botones ocultos, y se
     reetiqueta con la numeración del país (UK/EU/US/MX/AU/NZ) ---- */
  var sel = $('shoeSize');
  if (sel) {
    var sys = TH.sizeSystem();
    // Japón: las opciones ya vienen del diccionario en cm con medias tallas; no se reetiquetan
    if (sys[1] !== 'jp') Array.prototype.forEach.call(sel.options, function (o) {
      if (o.dataset && o.dataset[sys[1]]) o.textContent = sys[0] + ' ' + o.dataset[sys[1]];
    });
    if (sel.options[0] && sys[0]) sel.options[0].textContent = sel.options[0].textContent.replace(/\([^)]*\)\s*$/, '(' + sys[0] + ')');
    var apply = function () { var v = sel.value; if (!v) return; var b = sizesEl && sizesEl.querySelector('.size[data-size="' + v + '"]'); if (b) b.click(); else { selSize = v; updateAddBtn(); } };
    sel.addEventListener('change', apply); sizeSyncing = true; apply(); sizeSyncing = false;
  }

  /* ---- regalos según el pack (mentor, 23-oct-2026): 1 par ninguno · 2 uno · 3 dos · 5 los cuatro ----
     Orden de desbloqueo (usuario, 23-oct): AuraPod S (2) → + Travel Pack (3) → el pack completo (5).
     El pack de 3 alturas cuenta como 3 pares. */
  var LOCK_SVG = '<svg class="bonus-item__lock" viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="10.5" width="16" height="11" rx="2.2" fill="currentColor"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var GIFT_AT = [2, 2, 3, 5];   // pares que hacen falta (24-oct, usuario): perfume y e-book (2) · bolsa de viaje (3) · garantía (5)
  var bonusEls = document.querySelectorAll('.bonuses .bonus-item'), bonusTitle = document.querySelector('.bonuses__title'), bonusTotal = document.querySelector('.bonuses__total');
  var freeEl0 = bonusEls.length && bonusEls[0].querySelector('.bonus-item__free'), freeTxt = freeEl0 ? freeEl0.textContent : '', titleAll = bonusTitle ? bonusTitle.textContent : '';
  function updateGifts() {
    if (!bonusEls || !bonusEls.length) return;
    var n = selHeight === 'bundle' ? 3 : selPack, got = 0;
    Array.prototype.forEach.call(bonusEls, function (el, i) {
      var need = GIFT_AT[i] || 5, on = n >= need, f = el.querySelector('.bonus-item__free');
      el.classList.toggle('bonus-item--locked', !on);
      // 24-oct (usuario): bloqueado = candado rojo + "3 pares" (el "Desbloquea con 3 pares" cargaba demasiado)
      if (f) { if (on) f.textContent = freeTxt; else f.innerHTML = LOCK_SVG + t('{n} pairs', { n: need }); }
      if (on) got++;
    });
    if (bonusTitle) bonusTitle.textContent = got === 0 ? tt('🎁 Add a 2nd pair and get 2 FREE bonuses') : got === 1 ? tt('🎁 1 FREE bonus included with your order')
      : got === 2 ? tt('🎁 2 FREE bonuses included with your order') : got === 3 ? tt('🎁 3 FREE bonuses included with your order') : titleAll;
    if (bonusTotal) bonusTotal.hidden = got < bonusEls.length;   // el "has ahorrado" solo con los cuatro
  }
  // nombres que se entiendan (usuario, 24-oct): AuraPod S → perfume de feromonas, Travel Pack → bolsa de viaje,
  // Command Attention → e-book. La garantía se queda como está.
  [tt('Pheromone perfume'), tt('E-book: Command Attention'), tt('Travel bag')].forEach(function (name, i) {   // mismo orden que el HTML (make-src)
    var nm = bonusEls[i] && bonusEls[i].querySelector('.bonus-item__name'); if (nm) nm.textContent = name;
  });
  // "Has ahorrado X": la suma de los cuatro regalos tal como se ven (ya en la moneda del país).
  // El texto fijo lleva el importe en libras y en los idiomas con otra moneda no se convertía.
  function parseShown(txt) {
    var F = TH.FMT || {}, x = String(txt).replace(/[^\d.,]/g, '');
    if (F.group) x = x.split(F.group).join('');
    if (F.dec && F.dec !== '.') x = x.split(F.dec).join('.');
    return parseFloat(x) || 0;
  }
  var totalStrong = bonusTotal && bonusTotal.querySelector('strong');
  if (totalStrong && bonusEls.length) {
    var sum = 0;
    Array.prototype.forEach.call(bonusEls, function (el) { var w = el.querySelector('.bonus-item__was-top'); if (w) sum += parseShown(w.textContent); });
    if (sum > 0) totalStrong.textContent = TH.moneyMajor(sum);
  }
  // test 3 (ajuste del tema "bundle_test_on", apagado por defecto): la versión B no ofrece el pack de 3 alturas (el CSS esconde la tarjeta)
  // 26-oct: ganó la B → ajuste bundle_card_on apagado (html.ecm-no-bundle) = sin pack para todos
  var hc = document.documentElement.classList;
  if ((hc.contains('ecm-no-bundle') || (window.ECM_AB === 'B' && hc.contains('ecm-test-bundle'))) && selHeight === 'bundle') selHeight = '5';
  if (packsEl) packsEl.querySelectorAll('.pack').forEach(function (b) {
    var n = parseInt(b.dataset.pack, 10), g = document.createElement('span');
    g.className = 'pack__gift';
    g.textContent = n >= 5 ? tt('All 4 bonuses FREE') : n === 3 ? tt('+3 FREE bonuses') : n === 2 ? tt('+2 FREE bonuses') : '';
    b.appendChild(g);
  });

  /* ---- añadir al carrito ---- */
  addBtn.addEventListener('click', function () {
    var p = ECM.products[selHeight], v = p && p.variants[selSize];
    if (!v) return;
    addBtn.disabled = true;
    var h = selHeight, sz = selSize, q = selPack, pp = perPairFor(selHeight, selPack), src = window.__ecmAtcSrc || 'main';
    window.__ecmAtcSrc = '';
    TH.addWithProtection([{ id: v.id, quantity: selPack }]).then(function () {
      TH.trackAddToCart({ h: h, size: sz, qty: q, perPair: pp, variantId: v.id, source: src });
      TH.renderCart(); TH.openDrawer();
    })
      .catch(function (e) { console.error(e); alert(t('There was an issue with your cart. Please refresh and try again.')); })
      .then(function () { addBtn.disabled = false; });
  });

  selectHeight(selHeight);
  updatePackPrices(); updateAddBtn();

  /* ViewContent (Meta/TikTok) y Viewed Product (Klaviyo): mismo dato que la web,
     el precio de 5 cm en la moneda del mercado. Lo manda ecm-consent.js. */
  try {
    var p5 = ECM.products['5'];
    window.__ecmViewContent = { value: +((p5 ? p5.price : 0) / 100).toFixed(2), currency: ECM.currency };
    if (window.ExtraCMConsent && ExtraCMConsent.viewContent) ExtraCMConsent.viewContent(window.__ecmViewContent);
  } catch (e) {}

  /* ---- barra fija en móvil ---- */
  (function () {
    var bar = $('stickyCta'), btn = $('stickyCtaBtn'), out = $('stickyPrice');
    if (!bar || !btn) return;
    var sync = function () { var w = (lpOriginal && lpOriginal.style.display !== 'none') ? lpOriginal.textContent.trim() : ''; if (out) out.innerHTML = lpCurrent.textContent.trim() + (w ? ' <s>' + w + '</s>' : ''); };
    sync(); new MutationObserver(sync).observe(lpCurrent, { childList: true, characterData: true, subtree: true });
    var lab = btn.querySelector('.sticky-cta__label') || btn;
    var label = function () { lab.textContent = addBtn.disabled ? tt('Shop Now') : tt('Add to cart'); };
    label(); try { new MutationObserver(label).observe(addBtn, { attributes: true, childList: true, subtree: true }); } catch (e) {}
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting); }); }, { threshold: 0 }).observe(addBtn);
    btn.addEventListener('click', function () { if (!addBtn.disabled) addBtn.click(); else addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  })();

  /* ---- antes/después (arrastrar) ---- */
  document.querySelectorAll('.ba-slider').forEach(function (sl) {
    var before = sl.querySelector('.ba-slider__before-img'), handle = sl.querySelector('.ba-slider__handle'), knob = sl.querySelector('.ba-slider__knob');
    if (!before) return;
    function set(p) { p = Math.max(2, Math.min(98, p)); before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)'; if (handle) handle.style.left = p + '%'; if (knob) knob.style.left = p + '%'; }
    function move(e) { var r = sl.getBoundingClientRect(), cx = (e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX); set((cx - r.left) / r.width * 100); }
    var drag = false;
    sl.addEventListener('pointerdown', function (e) { drag = true; move(e); });
    window.addEventListener('pointermove', function (e) { if (drag) move(e); });
    window.addEventListener('pointerup', function () { drag = false; });
    set(50);
  });

  /* ---- carruseles con auto-avance ---- */
  function setupCarousel(trackId, opts) {
    var track = $(trackId); if (!track) return;
    var carousel = track.parentElement; if (!carousel) return;
    var speed = (opts && opts.speed) || 0.6, pauseMs = (opts && opts.pauseMs) || 3000;
    Array.prototype.slice.call(track.children).forEach(function (node) { track.appendChild(node.cloneNode(true)); });
    var pauseUntil = 0, last = performance.now(), pos = carousel.scrollLeft || 0, wasPaused = false;
    function tick(ts) {
      var dt = ts - last; last = ts;
      var paused = performance.now() < pauseUntil || document.hidden;
      if (paused) wasPaused = true;
      else {
        if (wasPaused) { pos = carousel.scrollLeft; wasPaused = false; }
        pos += speed * (dt / 16.67);
        var half = track.scrollWidth / 2;
        if (half > 0 && pos >= half) pos -= half;
        carousel.scrollLeft = pos;
      }
      requestAnimationFrame(tick);
    }
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { carousel.addEventListener(ev, function () { pauseUntil = performance.now() + pauseMs; }, { passive: true }); });
    requestAnimationFrame(tick);
  }
  setupCarousel('testiTrack', { speed: 0.6, pauseMs: 3000 });
  setupCarousel('videoTrack', { speed: 0.6, pauseMs: 3000 });

  /* ---- vídeos UGC: póster al acercarse, reproducción al entrar en pantalla ---- */
  document.querySelectorAll('.testi-track video, .video-track video').forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); });
  (function () {
    var vs = document.querySelectorAll('video[data-poster]'); if (!vs.length) return;
    function put(v) { if (v.getAttribute('data-poster')) { v.poster = v.getAttribute('data-poster'); v.removeAttribute('data-poster'); } }
    if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(vs, put); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { put(e.target); io.unobserve(e.target); } }); }, { rootMargin: '400px' });
    Array.prototype.forEach.call(vs, function (v) { io.observe(v); });
  })();
  if ('IntersectionObserver' in window) {
    ['.testi-carousel', '.video-carousel'].forEach(function (s) {
      var carousel = document.querySelector(s); if (!carousel) return;
      var vids = carousel.querySelectorAll('video'); if (!vids.length) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          vids.forEach(function (v) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else if (!v.paused) v.pause(); });
        });
      }, { rootMargin: '300px 0px' }).observe(carousel);
    });
  }
  document.querySelectorAll('.testi-track img, .video-track img').forEach(function (img) { img.decoding = 'async'; img.loading = 'eager'; });

  /* ---- modal de alturas ---- */
  (function () {
    var modal = $('heightModal'), openBtn = $('heightModalOpen'), closeBtn = $('heightModalClose'), grid = $('heightModalGrid');
    if (!modal || !openBtn || !grid) return;
    var populated = false;
    function populate() {
      if (populated) return;
      document.querySelectorAll('.heights-cards .height-card').forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; img.decoding = 'async'; });
        grid.appendChild(clone);
      });
      populated = true;
    }
    function open() { populate(); modal.classList.add('open'); modal.setAttribute('aria-hidden', 'false'); document.body.classList.add('modal-open'); }
    function close() { modal.classList.remove('open'); modal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('modal-open'); }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.querySelectorAll('[data-close-modal]').forEach(function (el) { el.addEventListener('click', close); });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });
  })();
})();

/* Barra de cuenta atrás de la cabecera (sección Cabecera del editor):
   evergreen por visitante, guardada en localStorage; al llegar a cero
   vuelve a empezar. El porcentaje lo pone updateLivePrice (misma regla que el hero). */
(function () {
  var bar = document.getElementById('offerBar'), el = document.getElementById('offerTimer');
  if (!bar || !el) return;
  var KEY = 'extracm_offer_end', hours = parseFloat(bar.getAttribute('data-hours')) || 8, end = 0;
  function reset() { end = Date.now() + hours * 3600e3; try { localStorage.setItem(KEY, String(end)); } catch (e) {} }
  try { end = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
  if (!end || end <= Date.now() || end > Date.now() + hours * 3600e3) reset();
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
    el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
    if (s <= 0) reset();
  }
  tick(); setInterval(tick, 1000);
})();
